module.exports = __webpack_public_path__ + "static/index/assets/img/logo.da052405.png";